import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/CustomerInfo",
    name: "CustomerInfo",
    meta:{
      title: '客户详情'
    },
    component: () => import("@/views/CustomerInfo")
  },
  {
    path: "/AddRecipientInfo",
    name: "AddRecipientInfo",
    meta:{
      title: '添加接收人'
    },
    component: () => import("@/views/AddRecipientInfo")
  },
  {
    path: "/NewAddRecipientInfo",
    name: "NewAddRecipientInfo",
    meta:{
      title: '添加接收人'
    },
    component: () => import("@/views/NewAddRecipientInfo")
  },
  {
    path: "/AddRecipient",
    name: "AddRecipient",
    meta:{
      title: '选择接收人'
    },
    component: () => import("@/views/AddRecipient")
  },
  {
    path: "/BuildPhone",
    name: "BuildPhone",
    meta:{
      title: '绑定手机号'
    },
    component: () => import("@/views/BuildPhone")
  },
  {
    path: "/MessageSwitch",
    name: "MessageSwitch",
    meta:{
      title: '设置'
    },
    component: () => import("@/views/MessageSwitch")
  },
  {
    path: "/ShopSwitch",
    name: "ShopSwitch",
    meta:{
      title: '店铺消息接收设置'
    },
    component: () => import("@/views/ShopSwitch")
  },
  {
    path: "/ChildInformation",
    name: "ChildInformation",
    meta:{
      title: '子账号分流设置'
    },
    component: () => import("@/views/ChildInformation")
  },
  {
    path: "/BuildAccount",
    name: "BuildAccount",
    meta:{
      title: '店铺账号绑定'
    },
    component: () => import("@/views/BuildAccount")
  },
  {
    path: "/ShowPhone",
    name: "ShowPhone",
    meta:{
      title: '手机号'
    },
    component: () => import("@/views/ShowPhone")
  },
  {
    path: "/ShowWeChat",
    name: "ShowWeChat",
    meta:{
      title: '微信昵称'
    },
    component: () => import("@/views/ShowWeChat")
  },
  {
    path: "/NoBuildShop",
    name: "NoBuildShop",
    meta:{
      title: '未绑定店铺'
    },
    component: () => import("@/views/NoBuildShop")
  },
  {
    path: "/WelfareH5",
    name: "WelfareH5",
    meta:{
      title: '用户福利'
    },
    component: () => import("@/views/WelfareH5/WelfareH5")
  },
  {
    path: "/Questionnaire",
    name: "Questionnaire",
    meta:{
      title: '问卷调查'
    },
    component: () => import("@/views/Questionnaire")
  },
  {
    path: "/Renew",
    name: "Renew",
    meta:{
      title: '专属奖励'
    },
    component: () => import("@/views/Renew")
  },
  {
    path: "/Renewal",
    name: "Renewal",
    meta:{
      title: '续费'
    },
    component: () => import("@/views/Renewal")
  },
  { // 入端版
    path: "/Renewal_RD",
    name: "Renewal_RD",
    meta:{
      title: '续费'
    },
    component: () => import("@/views/Renewal_RD")
  },
  {
    path: "/Welfare",
    name: "Welfare",
    meta:{
      title: '领取福利'
    },
    component: () => import("@/views/Welfare")
  },
  {
    path: "/WelfareClassPay",
    name: "WelfareClassPay",
    meta:{
      title: '领取福利'
    },
    component: () => import("@/views/WelfareClassPay")
  },
  {
    path: "/WelfareFebruary",
    name: "WelfareFebruary",
    meta:{
      title: '领取福利'
    },
    component: () => import("@/views/WelfareFebruary")
  },
  {
    path: "/WelfareFebruary/Questionnaire",
    name: "WelfareFebruary/Questionnaire",
    meta:{
      title: '领取福利'
    },
    component: () => import("@/views/WelfareFebruary/Questionnaire")
  },
  {
    path: "/WelfareFebruary/Warning",
    name: "WelfareFebruary/Warning",
    meta:{
      title: '领取福利'
    },
    component: () => import("@/views/WelfareFebruary/Warning")
  },
  {
    path: "/WelfareFebruary/AdditionalGive",
    name: "WelfareFebruary/AdditionalGive",
    meta:{
      title: '领取福利'
    },
    component: () => import("@/views/WelfareFebruary/AdditionalGive")
  },
  {
    path: "/WelfareFebruary/MarkPage",
    name: "WelfareFebruary/MarkPage",
    meta:{
      title: '领取福利'
    },
    component: () => import("@/views/WelfareFebruary/MarkPage")
  },
  {
    path: "/Subsidy",
    name: "Subsidy",
    meta:{
      title: '客服外包补贴'
    },
    component: () => import("@/views/Subsidy")
  },
  {
    path: "/TimeOut",
    name: "TimeOut",
    meta:{
      title: '领取福利'
    },
    component: () => import("@/views/MessagePush2021/TimeOut20210308")
  },
  {
    path: "/WarningTips",
    name: "WarningTips",
    meta:{
      title: '详情'
    },
    component: () => import("@/views/MessagePush2021/Info20210318")
  },
  {
    path: "/SuccessfulTrade",
    name: "SuccessfulTrade",
    meta:{
      title: '交易成功'
    },
    component: () => import("@/views/SuccessfulTrade")
  },
  {
    path: "/YesterdayBriefing",
    name: "YesterdayBriefing",
    meta:{
      title: '昨日简报'
    },
    component: () => import("@/views/YesterdayBriefing")
  },
  {
    path: "/YesterdayDetail",
    name: "YesterdayDetail",
    meta:{
      title: '客户类型'
    },
    component: () => import("@/views/YesterdayDetail")
  },
  {
    path: "/FilterSet",
    name: "FilterSet",
    meta:{
      title: '过滤消息设置'
    },
    component: () => import("@/views/FilterSet")
  },
  {
    path: "/MonitorType",
    name: "MonitorType",
    meta:{
      title: '监控消息类型'
    },
    component: () => import("@/views/MonitorType")
  },
  {
    path: "/Upgrade_RD",
    name: "Upgrade_RD",
    meta:{
      title: '领取优惠券'
    },
    component: () => import("@/views/Upgrade_RD")
  },
  {
    path: "/CouponPage",
    name: "CouponPage",
    meta:{
      title: '优惠券'
    },
    component: () => import("@/views/CouponPage")
  },

  // APP
  {
    path: "/AddressBookSearchPage",
    name: "AddressBookSearchPage",
    meta: { is_APP: true ,title: '通讯录' },
    component: () => import("@/views/AddressBookSearchPage")
  }, 
  {
    path: "/ImgTextPage",
    name: "ImgTextPage",
    meta: { is_APP: true ,title: '使用教程' },
    component: () => import("@/views/ImgTextPage")
  },
  {
    path: "/LabelPage",
    name: "LabelPage",
    meta: { is_APP: true ,title: '设置标签' },
    component: () => import("@/views/LabelPage")
  },
  {
    path: "/DetailsLabelPage",
    name: "DetailsLabelPage",
    meta: { is_APP: true ,title: '设置标签' },
    component: () => import("@/views/DetailsLabelPage")
  }, {
    path: "/ChatRoom",
    name: "ChatRoom",
    meta: { is_APP: true ,title: '聊天内容' },
    component: () => import("@/views/ChatRoom")
  }, {
    path: "/AddressBook",
    name: "AddressBook",
    meta: { is_APP: true ,title: '通讯录' },
    component: () => import("@/views/AddressBook")
  }, {
    path: "/CustomerMessage",
    name: "CustomerMessage",
    meta: { is_APP: true ,title: '客户消息' },
    component: () => import("@/views/CustomerMessage")
  }, {
    path: "/CustomerMessageSearchPage",
    name: "CustomerMessageSearchPage",
    meta: { is_APP: true ,title: '客户消息' },
    component: () => import("@/views/CustomerMessageSearchPage")
  }, {
    path: "/set",
    name: "set",
    meta: { is_APP: true ,title: '设置' },
    component: () => import("@/views/set")
  }, {
    path: "/CustomerWarn",
    name: "CustomerWarn",
    meta: { is_APP: true ,title: '客户预警' },
    component: () => import("@/views/CustomerWarn")
  }, {
    path: "/CustomerInfo_APP",
    name: "CustomerInfo_APP",
    meta: { is_APP: true ,title: '客户信息' },
    component: () => import("@/views/CustomerInfo_APP")
  }, {
    path: "/YesterdayBriefing_APP",
    name: "YesterdayBriefing_APP",
    meta: { is_APP: true ,title: '昨日简报' },
    component: () => import("@/views/YesterdayBriefing_APP")
  }, {
    path: "/SetRemark",
    name: "SetRemark",
    meta: { is_APP: true ,title: '设置备注和描述' },
    component: () => import("@/views/SetRemark")
  }, {
    path: "/SetCustomerInfo",
    name: "SetCustomerInfo",
    meta: { is_APP: true ,title: '资料设置' },
    component: () => import("@/views/SetCustomerInfo")
  }, {
    path: "/ServiceResponse",
    name: "ServiceResponse",
    meta: { is_APP: true ,title: '服务响应诊断' },
    component: () => import("@/views/ServiceResponse")
  },
  { // 固定通配路由,以上路由不匹配则导航至首页
    path: "*",
    name: "",
    redirect: '/CustomerInfo'
  },
  
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes
});

export default router;
